<template>
  <section v-if="articles.length">
    <JoszakiHeading :level="2">
      {{ $t("personProfile.myProfessionsRelatedArticles") }}
    </JoszakiHeading>
    <ul class="flex flex-col gap-2">
      <li v-for="article in articles" :key="article.seoTitle">
        <NuxtLink
          :to="
            localePath({
              name: 'blogArticlePage',
              params: { articleSeoName: article.seoTitle },
            })
          "
          class="text-primary hover:underline"
        >
          {{ article.title }}
        </NuxtLink>
      </li>
    </ul>
  </section>
</template>

<script>
import { ref, useContext, useFetch, computed } from "@nuxtjs/composition-api";
import ARTICLES_BY_PROFESSIONS from "./articlesByProfessions.graphql";

export default {
  name: "PersonProfessionRelatedBlogs",
  props: {
    person: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { $query } = useContext();
    const articles = ref([]);

    const professionIds = computed(() =>
      props.person?.professions?.map((p) => p.id) ?? []
    );

    useFetch(async () => {
      if (!professionIds.value.length) {
        return;
      }

      const result = await $query(ARTICLES_BY_PROFESSIONS, {
        professionIds: professionIds.value,
        articlesPerProfession: 2,
        maxArticles: 5,
      });

      articles.value = result?.articlesByProfessions?.items ?? [];
    });

    return {
      articles,
    };
  },
};
</script>
